import { render } from "./ApprovalDealReassignmentTable.vue?vue&type=template&id=653e9eb6&scoped=true"
import script from "./ApprovalDealReassignmentTable.vue?vue&type=script&lang=js"
export * from "./ApprovalDealReassignmentTable.vue?vue&type=script&lang=js"

import "./ApprovalDealReassignmentTable.vue?vue&type=style&index=0&id=653e9eb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653e9eb6"]])

export default __exports__